/* Importing the icons from the material-ui library. */
import {
  Dashboard as DashboardIcon,
  DevicesOther as DevicesOtherIcon,
  VideoCall as VideoCallIcon,
  // MicExternalOn as MicExternalOnIcon,
  AccountBox as AccountBoxIcon,
  Ballot as BallotIcon,
  Monitor as MonitorIcon,
  DashboardCustomize as DashboardCustomizeIcon,
  LocationOn as LocationOnIcon,
} from '@mui/icons-material';

/* Defining the navigation bar. */
const navConfig = [
  {
    title: 'Home',
    path: '/home',
    materialIcon: <DashboardIcon />,
  },
  {
    title: 'Patient List',
    path: '/patient/list',
    materialIcon: <BallotIcon />,
  },
  {
    title: 'Patient Registration',
    path: '/patient/register',
    materialIcon: <AccountBoxIcon />,
  },
  {
    title: 'Device',
    path: '/device/list',
    materialIcon: <DevicesOtherIcon />,
  },
  {
    title: 'Monitoring Dashboard',
    path: '/monitoring/list',
    materialIcon: <MonitorIcon />,
  },
  {
    title: 'Meeting',
    path: '/meeting/new',
    materialIcon: <VideoCallIcon />,
  },
  {
    title: 'Location',
    path: '/location/list',
    materialIcon: <LocationOnIcon />,
  },
  {
    title: 'Questionnaire',
    path: '/questionnaire/list',
    materialIcon: <BallotIcon />,
  },
  // {
  //   title: 'eSteth',
  //   path: '/esteth',
  //   materialIcon: <MicExternalOnIcon />,
  // },

  {
    title: 'COVID-19 Dashboard',
    path: '/covid19/dashboard',
    materialIcon: <DashboardCustomizeIcon />,
  },
  // {
  //   title: 'COVID-19 Patients',
  //   path: '/covid19/patientlist',
  //   icon: <PlaylistAddIcon />
  // }
];

/* Exporting the navConfig variable to be used in other files. */
export default navConfig;
